import { render } from "./Notifications.vue?vue&type=template&id=142b8441"
const script = {}

import exportComponent from "/home/gitlab-runner/builds/dhPKyzHk/0/den59k/reply200-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__